import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const modal = css`
  --gapBetweenModals: 0;
`;

export const cancelButton = css`
  ${breakpoints.from.smMobile} {
    margin-right: 32px;
  }

  ${breakpoints.only.smMobile} {
    margin-top: 16px;
  }
`;

// for some reason two wide button in modal footer will break whole layout
// in a curtain mode, but it can be fixed with overwriting height
export const modalContent = css`
  ${breakpoints.only.smMobile} {
    height: auto !important;

    & > div {
      min-height: auto !important;
    }
  }
`;

export const modalFooter = css`
  display: flex;
  justify-content: right;

  ${breakpoints.only.smMobile} {
    flex-direction: column-reverse;
    padding-top: 32px;
  }
`;
